// constants.js — medidas A4 e slots, originalmente copiadas do handler.py da Lambda
// mgs-lambda-etq (descontinuada). Esta é a fonte canônica das medidas.

const PAGE = { width: 595.3, height: 841.9 };

// Métricas hhea da Montserrat divididas por unitsPerEm (ascent 968, descent
// -251, em 1000). O ReportLab posiciona o texto pela baseline; o @react-pdf e o
// CSS, pelo topo da caixa de linha. Usar o mesmo ascender nos dois lados deixa
// as baselines no mesmo lugar; a line-height igual a ascent+descent zera o
// half-leading do CSS, para o editor cair exatamente sobre o PDF.
const MONTSERRAT_ASCENT = 0.968;
const MONTSERRAT_LINE_HEIGHT = 1.219;

// y_offset por slot: medido no template (quadro dourado interno); coluna dir ~0,2 pt abaixo.
const LABEL_SLOTS = [
  { y_offset: 0, x_offset: 0 },
  { y_offset: -0.21, x_offset: 260.6 },
  { y_offset: -156.29, x_offset: 0 },
  { y_offset: -156.5, x_offset: 260.6 },
  { y_offset: -311.88, x_offset: 0 },
  { y_offset: -312.08, x_offset: 260.6 },
  { y_offset: -467.58, x_offset: 0 },
  { y_offset: -467.79, x_offset: 260.6 },
  { y_offset: -623.08, x_offset: 0 },
  { y_offset: -623.29, x_offset: 260.6 },
];

const ELEMENT_LAYOUT = {
  nome: { x: 80, y: 775, font: ["Montserrat-Bold", 8.5], stroke: false },
  edition: { x: 80, y: 768, font: ["Montserrat-Light", 4.5], stroke: true },
  raridade: { x: 80, y: 763, font: ["Montserrat-Light", 4.5], stroke: true },
  infos: { x: 130, y: 763, font: ["Montserrat-Light", 4.5], stroke: true },
  surface: { x: 80, y: 754, font: ["Montserrat-Light", 6.5], stroke: true },
  centering: { x: 80, y: 747, font: ["Montserrat-Light", 6.5], stroke: true },
  edges: { x: 130, y: 754, font: ["Montserrat-Light", 6.5], stroke: true },
  corners: { x: 130, y: 747, font: ["Montserrat-Light", 6.5], stroke: true },
  // X legado; centralização horizontal usa gradeDisplayCenterX() + GRADE_DISPLAY_BOX.
  nota_geral: { x: 237.645, y: 755.7, font: ["Montserrat-Bold", 27], stroke: false },
  nome_nota: { x: 237.645, y: 747.5, font: ["Montserrat-Light", 5.0], stroke: true },
  serial: { x: 237.645, y: 741.5, font: ["Montserrat-Light", 5.5], stroke: true },
  qr: { x: 130, y: 689, width: 31, height: 31 },
};

// Quadro da nota (octógono interno). Do miolo branco para fora, primeira linha
// dourada em cada lado; calibrado no preview. Centro horizontal = x + width/2
// (nota geral, nome da nota, serial). ReportLab: canto inferior esquerdo (A4).
const GRADE_DISPLAY_BOX = {
  x: 214.23,
  y: 738.27,
  width: 46.83,
  height: 46.83,
};

// Layout simples (authentic / no_subgrades). A Lambda desenhava em
// Helvetica-Bold; aqui é Montserrat-Bold, a mesma fonte com que o validador
// mede e a tela desenha — medir numa métrica e desenhar em outra era a origem
// das âncoras compensatórias do handler legado.
const SIMPLE_LAYOUT = {
  name: { x: 75.59, y: 774.765, font: ["Montserrat-Bold", 10.5], stroke: false },
  number: { x: 256.7, y: 775.10006, font: ["Montserrat-Bold", 10], stroke: false },
  edition: { x: 79.68, y: 767.325, font: ["Montserrat-Bold", 6.5], stroke: false },
  right_top: { x: 253.055, y: 767.325, font: ["Montserrat-Bold", 6.5], stroke: false },
  raridade: { x: 79.68, y: 759.015, font: ["Montserrat-Bold", 6.5], stroke: false },
  right_middle: { x: 253.055, y: 759.015, font: ["Montserrat-Bold", 6.5], stroke: false },
  ano: { x: 79.68, y: 750.775, font: ["Montserrat-Bold", 6.5], stroke: false },
  right_auto: { x: 253.055, y: 750.775, font: ["Montserrat-Bold", 6.5], stroke: false },
  idioma: { x: 79.68, y: 742.215, font: ["Montserrat-Bold", 6.5], stroke: false },
  serial: { x: 253.055, y: 742.215, font: ["Montserrat-Bold", 6.5], stroke: false },
  qr: { x: 130, y: 689, width: 31, height: 31 },
};

// Larguras para alinhamento à direita (âncora em layout.x + slot.x_offset).
const SIMPLE_LAYOUT_WIDTHS = {
  name: 205.0 - 75.59,
  number: 256.7 - 220.0,
  edition: 205.0 - 79.68,
  right_top: 253.77 - 203.0,
  raridade: 170.0 - 79.68,
  right_middle: 253.77 - 220.0,
  ano: 120.0 - 79.68,
  right_auto: 253.77 - 212.0,
  idioma: 130.0 - 79.68,
  serial: 253.77 - 205.0,
};

// Pares esquerda ↔ direita da mesma linha. A caixa do texto alinhado à direita
// (PDF e tela) cobre a linha inteira, do x do campo à esquerda até a âncora:
// é o critério do validador (linha compartilhada). Com a área útil de
// SIMPLE_LAYOUT_WIDTHS (36,7 pt na numeração) o @react-pdf quebrava
// "288/SM-P" em "288/-" + "SM-P" por cima da linha de baixo.
const SIMPLE_LINE_PAIRS = {
  number: "name",
  right_top: "edition",
  right_middle: "raridade",
  right_auto: "ano",
  serial: "idioma",
};

const SIMPLE_LINE_WIDTHS = Object.fromEntries(
  Object.entries(SIMPLE_LINE_PAIRS).map(([right, left]) => [
    right,
    SIMPLE_LAYOUT[right].x - SIMPLE_LAYOUT[left].x,
  ])
);

export {
  PAGE,
  MONTSERRAT_ASCENT,
  MONTSERRAT_LINE_HEIGHT,
  LABEL_SLOTS,
  ELEMENT_LAYOUT,
  GRADE_DISPLAY_BOX,
  SIMPLE_LAYOUT,
  SIMPLE_LAYOUT_WIDTHS,
  SIMPLE_LINE_PAIRS,
  SIMPLE_LINE_WIDTHS,
};
